import axios from 'axios';
import ErrorHandler from './ErrorHandler';

class RequestHandler {
  private static errHandler = ErrorHandler;

  public static get(url: string, params: object = {}, headers: object = {}): Promise<any> {
    const parameters: object = Object.assign({ params }, { headers });
    return axios.get(url, parameters)
      .then(res => res.data || {})
      .catch(error => RequestHandler.errHandler.handleFailRequest(error));
  }

  public static delete(url: string, params: object = {}, headers: object = {}): Promise<any> {
    const parameters: object = Object.assign({ params }, { headers });
    return axios.delete(url, parameters)
      .then(res => res.data || {})
      .catch(error => RequestHandler.errHandler.handleFailRequest(error));
  }

  public static post(url: string, payload: object = {}, headers: object = {}): Promise<any> {
    return axios.post(url, payload, { headers })
      .then(res => res.data || {})
      .catch(error => RequestHandler.errHandler.handleFailRequest(error));
  }

  public static put(url: string, payload: object = {}, headers: object = {}): Promise<any> {
    return axios.put(url, payload, { headers })
      .then(res => res.data || {})
      .catch(error => RequestHandler.errHandler.handleFailRequest(error));
  }

  public static patch(url: string, payload: object = {}, headers: object = {}): Promise<any> {
    return axios.patch(url, payload, { headers })
      .then(res => res.data || {})
      .catch(error => RequestHandler.errHandler.handleFailRequest(error));
  }
}

export default RequestHandler;
